module.exports = __webpack_public_path__ + "img/1.ca1e4547.jpg";